// import React, { createContext, useState, useContext, useEffect } from "react";
// import { useNavigate } from "react-router-dom";

// const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   // const [email, setEmail] = useState(localStorage.getItem("email"));
//   // const [profileImg, setProfileImg] = useState(localStorage.getItem("profileImage") || "");

//   // const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem("isLoggedIn") === "true");
//   const [email, setEmail] = useState(null);
//   const [isLoggedIn, setIsLoggedIn] = useState(
//     !!localStorage.getItem("authToken")
//   );
//   const navigate = useNavigate();

//   // Sync email and isLoggedIn with localStorage
//   useEffect(() => {
//     if (email) {
//       localStorage.setItem("email", email);
//       localStorage.setItem("isLoggedIn", "true"); // Mark user as logged in

//       // if (profileImg) {
//       //   localStorage.setItem("profileImage", profileImg); // persist image
//       // }
//     } else {
//       localStorage.removeItem("email");
//       localStorage.removeItem("isLoggedIn"); // Remove login status
//       localStorage.removeItem("authToken");

//       // localStorage.removeItem("profileImage");
//     }
//   }, [email]);

//   // const login = (email) => {
//   //   setEmail(email);
//   //   setIsLoggedIn(true); // Set logged in status
//   //   navigate("/cards");
//   // };

//   const login = (email) => {
//     setEmail(email);
//     setIsLoggedIn(true);
//     navigate("/cards");
//   };

//   // const logout = () => {
//   //   setEmail(null);
//   //   setIsLoggedIn(false); // Set logged out status
//   //   localStorage.removeItem("email");
//   //   localStorage.removeItem("isLoggedIn");
//   //   localStorage.removeItem("authToken");
//   //   navigate("/");
//   // };

//   const logout = () => {
//     setEmail(null);
//     setIsLoggedIn(false);
//     localStorage.removeItem("authToken");
//     navigate("/");
//   };

//   return (
//     <AuthContext.Provider
//       value={{
//         email,
//         isLoggedIn,
//         login,
//         logout,
//         //  profileImg, setProfileImg
//       }}
//     >
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => useContext(AuthContext);

import React, { createContext, useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [email, setEmail] = useState(localStorage.getItem("email"));
  // const [profileImg, setProfileImg] = useState(localStorage.getItem("profileImage") || "");

  const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem("isLoggedIn") === "true");
  const navigate = useNavigate();

  // Sync email and isLoggedIn with localStorage
  useEffect(() => {
    if (email) {
      localStorage.setItem("email", email);
      localStorage.setItem("isLoggedIn", "true"); // Mark user as logged in

      // if (profileImg) {
      //   localStorage.setItem("profileImage", profileImg); // persist image
      // }

    } else {
      localStorage.removeItem("email");
      localStorage.removeItem("isLoggedIn"); // Remove login status
      localStorage.removeItem("authToken")

      
      // localStorage.removeItem("profileImage");

    }
  }, [email]);

  const login = (email) => {
    setEmail(email);
    setIsLoggedIn(true); // Set logged in status
    navigate("/cards");
  };

  const logout = () => {
    setEmail(null);
    setIsLoggedIn(false); // Set logged out status
    localStorage.removeItem("email");
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("authToken")
    sessionStorage.removeItem("u_t")
    navigate("/");
  };

  return (
    <AuthContext.Provider value={{ email, isLoggedIn, login, logout,
    //  profileImg, setProfileImg 
     }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

